import { useEffect } from "react";

export default function Seo({ title, description, path = "/", jsonLd = null, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const robotsEl = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      setMeta("name", "robots", "noindex, nofollow");
    } else if (robotsEl) {
      robotsEl.remove();
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (title) {
      setMeta("property", "og:title", title);
      setMeta("property", "og:site_name", "Dirty Church Chronicles");
    }
    setMeta("property", "og:url", `https://dirtychurchchronicles.com${path}`);
    setMeta("property", "og:image", `${window.location.origin}/api/uploads/og_image.png`);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `https://dirtychurchchronicles.com${path}`);
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.text = JSON.stringify(jsonLd);
      const old = document.getElementById("page-jsonld");
      if (old) old.remove();
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, path, jsonLd]);
  return null;
}
